/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/** One entry of `UC_UI.getServicesBaseInfo()`. */
export interface UsercentricsServiceInfo {
	categorySlug: string;
	consent?: {
		status: boolean;
	};
}

/**
 * The Usercentrics UI API. It installs itself as a browser global, so it has to be read off
 * `window` rather than imported. Only the accessor this module reads is described, and it is
 * optional because older Usercentrics builds do not expose it.
 */
export interface UsercentricsUi {
	getServicesBaseInfo?: () => UsercentricsServiceInfo[] | undefined;
}

const COOKIE_NAME = 'country_redirect_suppressed';
const COOKIE_DAYS = 180;

function isEssentialConsentGiven(): boolean {
	try {
		const services = (window as { UC_UI?: UsercentricsUi }).UC_UI?.getServicesBaseInfo?.();
		if (!services) return false;
		return services.some((s) => s.categorySlug === 'essential' && s.consent?.status === true);
	} catch {
		return false;
	}
}

export function setRedirectSuppressed(): void {
	// Only set cookie if user consented to essential cookies.
	// If UC is not present (dev env), set cookie normally.
	if ((window as { UC_UI?: UsercentricsUi }).UC_UI && !isEssentialConsentGiven()) return;

	const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
	document.cookie = `${COOKIE_NAME}=1; expires=${expires}; path=/; SameSite=Lax`;
}

export function isRedirectSuppressed(): boolean {
	return document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));
}
